// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o2-2";
export var chatLink = "_o2-0";
export var chatText = "_o2-1";